import "./style.scss";

import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { localizeDocLink } from "helpers/docLink";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IHelpdeskIcon {
    link: string;
    text?: string;
    transparent?: boolean;
    style?: React.CSSProperties;
}

const ExpandedHelpdeskIcon = ({ link, text, transparent = false, style }: IHelpdeskIcon) => {
    const [t] = useTranslation();

    const handleOpeningArticle = (e: any, link: string) => {
        e.preventDefault();
        window.open(link, "_blank");
    };

    const [isHovering, setIsHovering] = useState(false);

    return (
        <button
            className="helpdesk-expand-button"
            onClick={(e: any) => handleOpeningArticle(e, localizeDocLink(link))}
            style={{
                background: `${
                    transparent && isHovering ? "transparent" : !transparent && isHovering ? "#eef3fd" : "transparent"
                }`,
                ...style,
            }}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <HelpOutlineIcon className="btn-icon" />
            <span className="btn-text">{text ? text : t("Documentation.AccessDoc")}</span>
        </button>
    );
};

export default ExpandedHelpdeskIcon;
